import { useState } from "react";
import './index.css';
import styles from "./styles/App.module.css";
import Layout from "./components/layout.jsx";
import Initial from "./components/screens/initial";
import Appointment from "./components/screens/appointment";
import { Toaster } from 'react-hot-toast';

function App() {
	let [showSplashScreen, setShowSplashScreen] = useState(true);
	setTimeout(() => { setShowSplashScreen(false); }, 2500); // hide splash screen after 2 seconds

	let [screen, setScreen] = useState('initial');

	if( showSplashScreen )
	{
		return (
			<div className={styles.splash}>
				<img className={styles.splashLogo} src={require('./assets/images/logo.png')} alt="Logo on Splash Screen" />
			</div>
		);
	}
	else
	{
		return (
			<Layout currentScreen={screen} showInitialScreen={()=>{ setScreen('initial'); }} showAppointmentScreen={()=>{ setScreen('appointment'); }}>
				<Toaster />
				{screen==='initial' && <Initial/>}
				{screen==='appointment' && <Appointment showInitialScreen={()=>{ setScreen('initial'); }} />}
			</Layout>
		);
	}
}

export default App;
